import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    marketplaceFranchise: null,
    marketplaceFranchises: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const marketplaceFranchisesReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.MARKETPLACEFRANCHISE_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.MARKETPLACEFRANCHISE_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.MARKETPLACEFRANCHISE_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default marketplaceFranchisesReducer;
